import script from "./ExperienceForm.vue?vue&type=script&setup=true&lang=js"
export * from "./ExperienceForm.vue?vue&type=script&setup=true&lang=js"

import "./ExperienceForm.vue?vue&type=style&index=0&id=e0c0b590&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e0c0b590"]])

export default __exports__